import React from 'react';
import PropTypes from 'prop-types';
import TablePaginationActions from 'components/molecules/TablePaginationActions/TablePaginationActions';
import { Wrapper, TablePagination, WrapperLeft, WrapperRight } from './Pagination.styles';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const Pagination = ({
  totalRows,
  rowsPerPage,
  totalConnections,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  onDownload,
  totalTime,
}) => {
  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <Wrapper>
          <WrapperLeft>
            {/* {totalRows} records and {totalConnections} connections ({totalTime}) found */}
            {onDownload && (
              <Button
                onClick={() => {
                  onDownload('csv');
                }}
                size="small"
              >
                <DownloadIcon />
                csv
              </Button>
            )}

            {/* <Button
              onClick={() => {
                onDownload('xml');
              }}
              size="small"
            >
              <DownloadIcon />
              xml
            </Button>
            <Button
              onClick={() => {
                onDownload('json');
              }}
              size="small"
            >
              <DownloadIcon />
              json
            </Button> */}
          </WrapperLeft>
          <WrapperRight>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              sx={{ minHeight: '40px' }}
              labelRowsPerPage={'Records per page'}
            />
          </WrapperRight>
        </Wrapper>
      </tbody>
    </table>
  );
};

Pagination.propTypes = {
  totalRows: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
};

export default Pagination;
